import zh from "./zh_CN";
import en from "./en_US";
import Config from "../index";
import { get, strFormat } from "../../utils";

export class Language {
  static config = {
    zhCN: zh,
    enUS: en,
    ...Config.language,
  };
}

/**
 * 语言取得函数
 *
 * @param {*} code 语言路径
 * @param {*} self 组件实例 传this
 * @param {object} obj 字符串填值对象
 * @returns
 */
export const l = function (code, self, obj) {
  const [_, key] = code.split(".");
  const env = Config.languageEnv;
  const value = get(self, `props.language.${key}`, null);
  if (value instanceof Function) {
    return value(self);
  } else if (typeof value === "string") {
    return value;
  } else {
    const str = get(Language.config[env], code, "");
    if (obj == null) {
      return str;
    } else {
      return strFormat(str, obj);
    }
  }
};

/**
 * 根据下标找到对应的语言包
 *
 * @param {*} index
 * @returns
 */
export const findPackage = function (index) {
  const keys = Object.keys(Language.config);
  for (let i = 0; i < keys.length; i++) {
    const key = keys[i];
    if (index === i) {
      return Language.config[key];
    }
  }
};

export default Language.config[Config.languageEnv];



// WEBPACK FOOTER //
// ./src/yx-widget/config/language/index.js